import assertNever from 'assert-never';

import { FirmwareUpdateJobRequest, FirmwareUpdateStatus, ScheduledJobType } from '@shure/cloud/shared/models/devices';
import { DeviceModel, DeviceStatus } from '@shure/shared/angular/data-access/system-api/models';

import { FirmwareUpdateExecutionStage, ScheduledJobRequestFragment } from '../graphql/generated/cloud-sys-api';

import { mapDeviceModelFromSysApi, mapFirmwareUpdateExecutionStageFromSysApi } from './utils';

export function mapScheduledJobRequestFromSysApi(
	scheduledJobRequest: ScheduledJobRequestFragment | null | undefined
): FirmwareUpdateJobRequest | undefined {
	if (scheduledJobRequest === undefined || scheduledJobRequest === null) return undefined;

	if (scheduledJobRequest.details.__typename === 'FirmwareUpdateJobRequestDetails') {
		const device = scheduledJobRequest.details.task.device;
		const isKnown = device.__typename === 'Device';
		const result = scheduledJobRequest.details.result;

		const jobRequest: FirmwareUpdateJobRequest = {
			id: scheduledJobRequest.id,
			type: ScheduledJobType.FirmwareUpdate,
			status: scheduledJobRequest.status,
			jobId: scheduledJobRequest.job.jobId,
			executeAt: scheduledJobRequest.job.executeAt,
			// Only known devices (Device type) have node IDs; unknown devices don't
			task: {
				packageKey: scheduledJobRequest.details.task.packageKey,
				packageVersion: scheduledJobRequest.details.task.packageVersion,
				hosted: scheduledJobRequest.details.task.hosted,
				device: {
					known: isKnown,
					nodeId: isKnown ? device.id : undefined,
					hardwareId: device.hardwareId,
					model: isKnown
						? device.interface?.model
							? mapDeviceModelFromSysApi(device.interface?.model)
							: DeviceModel.UNKNOWN
						: mapDeviceModelFromSysApi(device.model),
					status: isKnown ? <DeviceStatus>device.status : DeviceStatus.Offline,
					name: isKnown ? device.features.name?.name : device.name ?? undefined,
					currentFirmwareVersion: isKnown
						? device.features.firmware?.version
						: device.firmwareVersion ?? undefined
				}
			},
			result: result
				? {
						percentComplete: result.percentComplete,
						// TODO - fix when we migrate to FW Update V2.
						status: <FirmwareUpdateStatus>(<unknown>result.status),
						stage: mapFirmwareUpdateExecutionStageFromSysApi(
							result.stage ?? FirmwareUpdateExecutionStage.Verifying
						),
						error: result.error ?? undefined
				  }
				: undefined
		};

		return jobRequest;
	}

	return assertNever(scheduledJobRequest.details.__typename);
}
